export class AttachmentScanPendingError extends Error {}

/** Only accepted is a success. Provider errors (including 429) stop polling. */
export async function waitForAttachmentScan<T extends { status: string }>(
  initial: T,
  options: {
    read: () => Promise<T>;
    waiting: () => void;
    current: () => boolean;
    delay?: () => Promise<void>;
    maximumPolls?: number;
  },
): Promise<T> {
  let result = initial;
  const delay =
    options.delay ??
    (() => new Promise<void>((resolve) => setTimeout(resolve, 15_000)));
  const maximum = options.maximumPolls ?? 80;
  for (let count = 0; ; count++) {
    if (!options.current()) throw new Error("attachment-context-changed");
    if (result.status === "accepted") return result;
    if (result.status !== "uploaded") throw new Error("attachment-rejected");
    if (count >= maximum)
      throw new AttachmentScanPendingError("attachment-scan-pending");
    options.waiting();
    await delay();
    if (!options.current()) throw new Error("attachment-context-changed");
    result = await options.read();
  }
}
